var exports = {
  "I": "x1cb7f6e3--df7e6f--chips",
};

module.exports = exports;
